import React from 'react';
import LocationSection from './LocationSection'
import Photos from './Photos'

// import storyPhoto from '../img/wigs_comp.jpg'

// import FontAwesomeIcon from '@fortawesome/react-fontawesome'
// import angleDown from '@fortawesome/fontawesome-free-solid/faAngleDown'
// import angleUp from '@fortawesome/fontawesome-free-solid/faAngleUp'

import WithAnimation from './WithAnimation'
import { Power4 } from "gsap";
import '../css/About.css'

class About extends WithAnimation {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    this.Timeline.to('#story-1', 1, {height: "1200px", ease: Power4.easeInOut})
  }

  render() {
    return (
      <div className="about">
        <LocationSection { ...this.props } />
        <Photos { ...this.props } />
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js